var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanningOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63457 2.19488C6.33202 0.982143 7.59447 0.199951 9.00189 0.199951C10.4093 0.199951 11.6718 0.982143 12.3692 2.19488H16.0588C17.0655 2.19488 17.8 3.04715 17.8 3.99488V8.91436H16.2V3.99488C16.2 3.92402 16.1735 3.86972 16.1418 3.83607C16.1109 3.80325 16.0816 3.79488 16.0588 3.79488H11.3367L11.1327 3.29942C10.7487 2.36669 9.9008 1.79995 9.00189 1.79995C8.10299 1.79995 7.25505 2.36669 6.87107 3.29942L6.66711 3.79488H1.94119C1.91845 3.79488 1.88912 3.80325 1.85824 3.83607C1.82656 3.86972 1.80001 3.92402 1.80001 3.99488V20.9949C1.80001 21.0657 1.82656 21.12 1.85824 21.1537C1.88912 21.1865 1.91845 21.1949 1.94119 21.1949H9.50219V22.7949H1.94119C0.934565 22.7949 0.200012 21.9426 0.200012 20.9949V3.99488C0.200012 3.04715 0.934564 2.19488 1.94119 2.19488H5.63457Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16954 5.89098H13.7836V7.09098H4.16954V5.89098Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16954 8.89098H13.7836V10.091H4.16954V8.89098Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16954 11.891H9.64261V13.091H4.16954V11.891Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2 17C10.2 13.2444 13.2445 10.2 17 10.2C20.7555 10.2 23.8 13.2444 23.8 17C23.8 20.7555 20.7555 23.8 17 23.8C13.2445 23.8 10.2 20.7555 10.2 17ZM17 11.8C14.1281 11.8 11.8 14.1281 11.8 17C11.8 19.8718 14.1281 22.2 17 22.2C19.8719 22.2 22.2 19.8718 22.2 17C22.2 14.1281 19.8719 11.8 17 11.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6 13.4V16.4H19.6V17.6H16.4V13.4H17.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningOutlinedIcon);
export default __webpack_public_path__ + "static/media/planning-outlined-icon.8090e636f8fd4d6993a3f605f2cb1247.svg";
export { ForwardRef as ReactComponent };